import { render, staticRenderFns } from "./FeaturedMenuItem.vue?vue&type=template&id=b47ced54&"
import script from "./FeaturedMenuItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports